export default {
  lang: 'Português',
  homeScreen: {
    title: '', // Específico do produto
    stayConnected: 'Mantenha-se Conectado',
    comingSoon: 'Em Breve',
    messages: 'Mensagens',
    subtitle: '',
  },
  glassWidgets: {
    errors: {
      requestFailed: 'Algo deu errado. Por favor, tente novamente mais tarde.',
    },
    programStatus: {
      title: 'Meu Status',
      loading: 'Carregando…',
      yourRep: 'Seu Rep',
      myProfile: 'Meu Perfil',
      favorites: 'Favoritos',
      registeredOn: 'Inscrito em:',
      graduatedOn: 'Formado em:',
      totalBadgesEarned: 'Total de Emblemas Conquistados:',
      lastBookingLogged: 'Última Reserva Registrada:',
      currentTier: 'Nível Atual',
      lastBadgeEarned: 'Último Emblema Conquistado:',
      currentFocus: 'Foco Atual:',
      changeProfilePicture: 'Alterar Foto de Perfil',
    },
    todaysfocus: {
      title: 'Foco de Hoje',
      empty: 'Nenhum item de foco para hoje',
      loading: 'Carregando…',
      error: 'Algo deu errado',
      slideNavAria: 'Navegação de slides',
      slideAria: 'Slide',
      carouselAria: 'Foco de hoje',
    },
    welcome: 'Bem-vindo!',
    welcomeBack: 'Bem-vindo de volta, {firstName}!',
    notifications: {
      loading: 'Carregando…',
      empty: 'Sem notificações',
    },
    achievements: {
      title: 'Recompensas & Concursos',
      loading: 'Carregando…',
      lastBooking: 'Última Submissão',
      currentTier: 'Nível Atual',
      contestEntries: 'Total de Participações em Concursos',
      nightsBooked: 'Noites Reservadas',
      totalRevenue: 'Receita Total Reportada',
      noBookingData: 'Nenhum dado de reserva disponível.',
      notAvailable: 'N/D',
      fileUploadSuccess: 'O arquivo foi enviado com sucesso.',
      quickSubmit: {
        title: 'Envio rápido',
        uploading: 'Enviando…',
        clear: 'Limpar',
        submit: 'Enviar',
        submitSuccessSimulated: 'Reserva enviada com sucesso',
      },
    },
  },
  notification: {
    newAndNow: 'Novidades & Agora!',
    alert: 'Alerta',
    message: 'Mensagem',
    badge: 'Nova Conquista',
    contest: 'Concurso',
    'content-update': 'Atualização de Conteúdo',
    events: 'Eventos',
    other: 'Notificação',
    welcome: 'Bem-vindo',
  },
  loginScreen: {
    version2custom: {
      defaultAmbassador: {
        step2: 'Etapa 1: Criar Uma Conta',
        step3: 'Etapa 2: Criar Seu Perfil',
      },
      houstonInsider: {
        hospitalityCheckboxLabel:
          'Este programa está atualmente limitado aos trabalhadores do setor hoteleiro e de restauração sediados em Houston. Embora esperemos alargar os critérios de elegibilidade no futuro, tenha em atenção que os participantes que não cumpram os requisitos atuais poderão ser excluídos do programa',
      },
      app1857: {
        fields: {
          howDiscoveredKLA: 'Como descobriu a Key Lime Academy?',
          tradeshowDetailLabel: 'Em que feira ou conferência?',
          tradeshowDetailPlaceholder: 'Por favor, introduza o nome da feira ou conferência',
          discoverVisitFloridaKeys: 'Visite o site da Florida Keys',
          discoverSearchEngine: 'Motor de busca (por exemplo, Google, Yahoo)',
          discoverAiTool: 'Ferramenta de IA/pesquisa (por exemplo, ChatGPT, Perplexity)',
          discoverSocialMedia: 'Redes sociais (por exemplo, Instagram, X, Facebook, LinkedIn)',
          discoverEmailNewsletter: 'E-mail ou newsletter',
          discoverWordOfMouth: 'Boca a boca',
          discoverTradeshowConference: 'Feira ou conferência (indique-nos qual)',
          discoverOtherTravproAffiliate: 'Outros sites afiliados da TravPRO',
        },
      },
      app1865: {
        fields: {
          topTravelType: 'Qual é o tipo de viagem que você mais vende?',
          travelTypeAdventure: 'Aventura/Aventura Leve/Expedição',
          travelTypeAllInclusive: 'Tudo Incluído',
          travelTypeBusinessMice: 'Negócios/MICE',
          travelTypeCultureExperiential: 'Cultura/Experiencial',
          travelTypeCruise: 'Cruzeiro',
          travelTypeFamilyMultiGen: 'Família/Multigeracional',
          travelTypeRomance: 'Romance/Casamento/Lua de Mel',
          travelTypeLuxury: 'Luxo',
          travelTypeRail: 'Trem',
          travelTypeTours: 'Passeios',
          travelTypeWellness: 'Bem-estar/Saúde/Spa',
          travelTypeLgbtq: 'LGBTQ+',
        },
      },
      app1826: {
        fields: {
          optMarketing:
            'Mantenha-se em contacto com a equipa do setor de viagens e os parceiros deste programa e receba atualizações.',
        },
      },
      app842: {
        fields: {
          segments: 'Qual(is) segmento(s) você vende principalmente?',
          segmentLeisure: 'Lazer',
          segmentCorporate: 'Corporativo',
          segmentGroup: 'Grupo',
        },
      },
    },
    version2: {
      homeTitle: 'Vamos ver se conseguimos encontrar um perfil existente para você em nosso sistema.',
      homeTitleSub:
        'Digite o endereço de e-mail que você normalmente usa para fazer login em programas de treinamento.',
      noAccount: 'Nenhuma conta encontrada ({email}), por favor tente com outro e-mail ou crie uma conta agora.',
      continueButton: 'Continuar',
      success: 'Conta atualizada com sucesso! Você será redirecionado em breve para a página inicial.',
      successNewAccount:
        'Para completar seu registro, você receberá um e-mail de confirmação para verificar sua conta.',
      loginButton: 'Entrar',
      matchFound: 'Encontramos uma correspondência, por favor preencha sua senha para continuar.',
      magicLink: 'Entrar através de um link em seu e-mail:',
      magicLinkButton: 'Solicitar Link Mágico',
      magicLinkTitle: 'Receba um link direto enviado para seu e-mail que o conectará instantaneamente.',
      otherEmailButton: 'Enviar',
      title:
        'Por favor, reserve um momento para completar todas as informações abaixo, pois isso preencherá seu perfil pessoal e informações de contato.',
      titleIndustry:
        'Por favor, reserve um momento para completar todas as informações abaixo, pois isso preencherá seu perfil pessoal e informações de contato.',
      register: 'Criar uma conta',
      agent: 'Consultor de Viagem',
      visitor: 'Visitante da Indústria',
      ambassador: 'Embaixador',
      step1: 'Etapa 1: Tipo de Usuário',
      step2: 'Etapa 2: Criar Uma Conta',
      step3: 'Etapa 3: Criar Seu Perfil',
      marketingOptIn:
        'Tem certeza de que não está interessado em se manter conectado com a equipe comercial de viagens deste programa?',
      optIn: 'Sim, Estou Interessado',
      optOut: 'Não Interessado',
      step2Sub1: 'Conte-nos Sobre Você',
      step2Sub2: 'Conte-nos Sobre Seu Negócio',
      step2Sub3: 'Fale-nos sobre sua empresa',
      privacyHead: 'PREFERÊNCIAS DE COMUNICAÇÃO',
      privacySub:
        'Marque as caixas abaixo para garantir que você receba comunicações importantes da equipe comercial de viagens do fornecedor (atualizações e anúncios de produtos, recompensas, incentivos, FAMs, etc.) e iniciativas de suporte de vendas e networking comercial de viagens da TravPRO Mobile.',
      privacy: 'Protegemos sua privacidade e nunca vendemos, fazemos mau uso ou traímos sua confiança.',
      store: 'Baixe facilmente este programa na sua loja de aplicativos:',
      powered: 'DESENVOLVIDO POR',
      toastMessage: {
        forgotSuccess:
          'Enviamos por e-mail seu link de redefinição de senha! Você será redirecionado para a página de login em 10 segundos.',
        emailNotExisting: 'O endereço de e-mail que você digitou não existe.',
        magicLinkMessage: 'Por favor aguarde, estamos conectando você agora.',
        magicLinkError:
          'Não conseguimos encontrar sua conta em nosso banco de dados, por favor faça login manualmente. Você será redirecionado em 10 segundos.',
        magicLinkError1:
          'Não conseguimos encontrar um token válido, por favor faça login ou solicite um novo link mágico. Se este problema persistir, entre em contato conosco em: info@travpromobile.com.',
        magicLinkError2:
          'Não conseguimos encontrar sua conta em nosso banco de dados, por favor faça login manualmente. Você será redirecionado em 10 segundos.',
        magicLinkSuccess: 'Verifique seu e-mail em {email}. Ele tem um link mágico que o conectará.',
        magicLinkErrorWait: 'Por favor aguarde 5 minutos entre solicitações de link mágico.',
        emailNotFoundError:
          'O endereço de e-mail que você digitou não pode ser encontrado em nossos registros. Por favor verifique erros de digitação ou crie uma conta.',
      },
      errors: {
        zipCodeNotFound: 'CEP não encontrado, tente novamente',
        zipCodeOnlyNumbers: 'CEP pode conter apenas números',
        password: 'Por favor digite uma senha',
        passwordNotMatching: 'As senhas que você digitou não coincidem',
        passwordTooShort: 'A senha precisa ter pelo menos 8 caracteres',
        emailExists:
          'Este endereço de e-mail já existe ou é inválido. Por favor tente com outro endereço de e-mail ou faça login em sua conta.',
        fillInAllFields: 'Por favor preencha todos os campos obrigatórios',
        fillInEmail: 'Por favor preencha seu e-mail.',
        emailNotExisting: 'O endereço de e-mail que você digitou não existe.',
      },
      fields: {
        forgotSubCopy: 'Esqueceu sua senha e quer alterá-la? ',
        forgotSubCopy2:
          'Quer pular a senha completamente? Enviaremos um e-mail com um link mágico que o conectará automaticamente ao programa. ',
        city: 'Cidade',
        companyName: 'Nome da Empresa',
        role: 'Sua Função',
        description: 'O que melhor descreve o negócio da sua empresa?',
        country: 'País',
        password: 'Senha',
        passwordRegister: 'Escolha uma Senha (mínimo de 8 caracteres)',
        passwordConfirm: 'Confirmar Senha',
        firstName: 'Primeiro Nome (Nome)',
        lastName: 'Sobrenome (Família)',
        agency: 'Nome da Sua Agência',
        employer: 'Nome da empresa',
        employerRole: 'Qual opção descreve melhor sua função?',
        employerYears: 'Há quantos anos você mora na região onde trabalha?',
        title: 'Sua Função (Selecione Uma)',
        company: 'Nome da Empresa',
        select: 'Selecione uma opção abaixo',
        state: 'Estado',
        province: 'Província/Região/Estado',
        zipCode: 'CEP',
        postalCode: 'Código Postal',
        affiliate: 'Qual grupo é a PRINCIPAL afiliação da sua agência?',
        hostAgency: 'Sua Agência Hospedeira?',
        ataCliaArc: 'Qual é o seu número ATA/CLIA/ARC?',
        executive: 'Executivo',
        management: 'Gestão',
        marketing: 'Marketing',
        sales: 'Vendas',
        coordinator: 'Coordenador',
        other: 'Outro',
        opt: 'Mantenha-se conectado com a equipe comercial de viagens deste programa e receba atualizações.',
        optMarketing: 'Mantenha-se conectado com a TravPRO sobre programas e eventos similares.',
        retail: 'Loja Física',
        home: 'Agente Home-Based',
        independent: 'Contratante Independente',
        host: 'Agência Hospedeira',
        call: 'Call Center ou Agência Web',
        describes: 'O que melhor descreve você e o negócio da sua agência? ',
        invalidEmail: 'Insira um endereço de e-mail válido',
        roleDMO: 'DMO',
        roleEventEmployee: 'Funcionário de evento',
        roleHotelEmployee: 'Funcionário de hotel',
        roleRestaurantBar: 'Funcionário de restaurante/bar',
        roleRetailService: 'Funcionário de varejo e serviços',
        roleTourActivity: 'Funcionário de operadora de turismo e atividades',
        roleTransportation: 'Funcionário de transporte',
        roleOther: 'Outros',
        yearsJustArrived: 'Acabou de chegar (<6 meses)',
        years1to5: '1 a 5 anos',
        years5to10: '5 a 10 anos',
        years10Plus: 'Mais de 10 anos',
      },
    },
    title: 'Programa de Treinamento e Capacitação de Vendas para Profissionais de Viagem', // Específico do produto (texto TravPRO ou ChannelPRO)
    welcome: {
      headerTop: 'Bem-vindo ao',
    },
    sellingPoints: {
      // Todos os pontos de venda podem ser específicos do produto
      0: 'Aprenda, Promova e Venda em Movimento',
      1: 'Treinamento Multimídia em Todos os Dispositivos',
      2: 'Certificado de Conclusão',
      3: 'Apresentações de Vendas Prontas',
      4: 'Materiais Promocionais de Alto Impacto',
      5: 'Dicas Privilegiadas e Promoções',
      6: 'Diretório de Produtos em Tempo Real',
      7: 'Notícias e Atualizações Oportunas',
    },
    emailPrompt:
      'Por favor digite seu endereço de e-mail e senha para confirmar que você é um profissional de viagens.', // Específico do produto (texto TravPRO ou ChannelPRO)
    tAndC: {
      agree: 'Ao continuar você concorda com nossa ',
      privacyPolicy: 'política de privacidade',
      and: ' e ',
      termsConditions: 'termos e condições',
    },
    fields: {
      what: 'Que tipo de viagem você vende?',
      what1: 'Qual é o tipo #1 de viagem que você vende?',
      what2: 'Qual é o tipo #2 de viagem que você vende?',
      what3: 'Qual é o tipo #3 de viagem que você vende?',
      agency: 'Agência *',
      email: 'E-mail',
      password: 'Senha',
      passwordConfirm: 'Confirme sua senha *',
      firstName: 'Primeiro nome *',
      lastName: 'Sobrenome *',
      agencyName: 'Nome da Agência *',
      city: 'Cidade *',
      stateProvince: 'Estado / Província *',
      salutation: 'Tratamento *',
      required: 'Obrigatório',
      invalidEmail: 'Endereço de e-mail inválido',
      complete: 'Etapa 2: Complete seu perfil',
      tell: 'Conte-nos Sobre Você',
      title: 'Cargo Profissional *',
      host: 'Nome da Agência Hospedeira',
      country: 'País / Região',
      select: 'Por favor selecione uma opção abaixo',
      header2: 'Qual(is) segmento(s) você vende principalmente?',
      step2: 'Descreva Seu Negócio',
      leisure: 'Lazer',
      corporate: 'Corporativo',
      group: 'Grupo',
      affiliate: 'Qual é Sua Principal Afiliação?',
      forgot: 'Esqueceu sua senha? Clique no botão abaixo e enviaremos um e-mail para redefinir sua senha.',
    },
    noAgent: {
      noAgentButton: 'Não sou um consultor',
      title: 'Obrigado pelo seu interesse em\n{clientName}', // Específico do produto
      messageWeb:
        'O conteúdo neste site é exclusivo para profissionais de viagem.\nPara saber mais sobre {clientName}, por favor visite: ', // Específico do produto
      messageMobile:
        'Algum conteúdo neste app é exclusivo para profissionais de viagem, mas fique à vontade para navegar por uma prévia do que este app tem a oferecer pressionando "Continuar".', // Específico do produto
      continue: 'Continuar',
      visitWebsite: 'Visitar website',
    },
    newUser: 'Novo Usuário',
    register: 'Registrar',
    registered: 'Este e-mail já está registrado',
    forgot: 'Redefinir Senha',
    header:
      'Por favor reserve um momento para completar todas as informações abaixo, pois isso é o que preencherá seu perfil e informações de contato.',
    step1: 'Etapa 1: Complete seu endereço de e-mail e escolha uma senha.',
  },
  welcomeScreen: {
    helloUser: 'Olá {{name}}',
    hello: 'Olá,',
    fromAgency: 'da {{agency}}',
    notUser: 'Não é {{name}}?',
    introOnline:
      'Treine imediatamente online ou pré-carregue o conteúdo para que esteja sempre disponível para uso offline!',
    introOffline:
      'Você já tem a versão mais recente pré-carregada. Comece a treinar ou vender a qualquer hora, em qualquer lugar!',
    startTraining: 'Começar a aprender',
    continueTraining: 'Continuar aprendendo',
    graduated: 'Parabéns!',
    downloader: {
      preload: 'Pré-carregar',
      stop: 'parar',
      init: 'Inicializando...',
      lastUpdate: 'Última atualização: ',
    },
  },
  trainingScreens: {
    start: 'Iniciar',
    continue: 'Continuar',
    review: 'Revisar',
    restart: 'Reiniciar',
    durationInMinutes: '{number} minutos',
    percentageComplete: '{number}% Completo',
    unlock: 'Desbloqueie este capítulo completando o capítulo de treinamento {number}.',
    unlockFoundation: 'Desbloqueie este capítulo completando o capítulo de treinamento {number}.',
    unlockSpecialization: 'Desbloqueie obtendo seu certificado.',
    unlockPartners: 'Desbloqueie obtendo seu certificado.',
    unlockRetain: 'Desbloqueie este capítulo completando os fundamentos em {name}.',
    unlockSubtitle: 'Desbloqueie mais capítulos completando capítulos de treinamento.',
    allUnlocked: 'Você desbloqueou todos os capítulos!',
    certificate: 'Certificado',
    courseComplete: 'Continuar',
    endReached: 'Você chegou ao fim',
    retainEnd:
      'Use a barra superior para navegar neste capítulo ou pressione o botão voltar para retornar à visão geral.',
    watchListenRead: 'Assista, Ouça e Leia mais',
    trouble:
      'Parece que você está tendo dificuldades, por favor releia o conteúdo da(s) página(s) anterior(es) e tente novamente.',
    confirm: 'Confirme sua resposta',
    choose: 'Por favor escolha uma resposta',
    skip: 'Retornar >',
    viewAllTitle: 'Dica de treinamento',
    viewAll:
      'Para prosseguir para a próxima página, certifique-se de revisar todo o conteúdo da página. Isso pode incluir assistir a todos os vídeos, clicar nos ícones para visualizar materiais complementares e responder corretamente às páginas de perguntas. Essas informações úteis foram fornecidas para aprimorar seu treinamento e garantir que você alcance o status PRO.',
    fillBlanks: 'Preencha o(s) espaço(s) em branco:',
    next: 'Próxima pergunta',
    retry: 'Tentar Novamente',
    fastTrackContinue: 'Continuar Fast Track',
    fastTrackMoveToFull: 'Cancelar Fast Track',
    fastTrackPrompt:
      'Você já se considera um especialista em BVI? Gostaria de tentar obter sua certificação pelo Fast Track? Uma tentativa, 15 perguntas, nota mínima de aprovação: 80% (B).',
    grading: 'Sua nota final é: {grade}',
  },
  nav: {
    home: 'Início',
    train: 'Treinar',
    learn: 'Aprender',
    retain: 'Reter',
    directory: 'Diretório',
    showRoom: 'Vitrines',
    showcases: 'Vitrines',
    destinationShowcases: 'Destino\nVitrines',
    offers: 'Ofertas',
    promote: 'Promover',
    sell: 'Vender',
    info: 'Info',
    rewards: 'Recompensas',
    achievements: 'Conquistas',
    media: 'Mídia',
    favorites: 'Favoritos',
    contact: 'Conheça a Equipe',
    reportCard: 'Ver Diploma',
    accountSettings: 'Configurações da Conta',
    changeProfileImage: 'Alterar imagem do perfil',
    messages: 'Mensagens',
    search: 'Buscar',
    manageImpersonation: 'Personificar usuário',
  },
  impersonateView: {
    title: 'Personificar usuário',
    description:
      'Digite o endereço de e-mail do usuário que você deseja personificar. Você já precisa estar autenticado para que a personificação funcione.',
    returnToApp: 'Voltar ao app',
    emailLabel: 'Endereço de e-mail',
    startImpersonation: 'Iniciar personificação',
    impersonating: 'Personificando…',
    confirmImpersonation: 'Confirmar personificação',
    confirming: 'Confirmando…',
    endImpersonation: 'Encerrar personificação',
    ending: 'Encerrando…',
    currentlyImpersonating: 'Você está personificando {email} no momento. Você pode encerrar a personificação abaixo.',
    missingEmail: 'Por favor, digite um endereço de e-mail para personificar.',
    tokenFetched: 'Token de personificação obtido para {email}. Revisando o perfil antes de confirmar.',
    previewFailed: 'Falha ao buscar o perfil do usuário para personificação.',
    startFailed: 'Falha ao iniciar a personificação. Tente novamente.',
    confirmFailed: 'Falha ao confirmar a personificação. Tente novamente.',
    endFailed: 'Falha ao encerrar a personificação. Tente novamente.',
    previewLabel: 'Resposta da personificação',
  },
  contentHeaders: {
    train: 'Treinar',
    retain: 'Reter',
    subapps: ' Módulos de MicroAprendizado de Parceiros',
    subAppsFull: ' COMPANIONS DE VENDAS DE PARCEIROS',
    maintrainings: 'A Base',
    subtrainings: 'A Experiência',
    fastTrack: 'Fast Track',
  },
  pageDescriptions: {
    train: 'Eduque, engaje e torne-se o especialista.',
    trainAmbassador: 'Eduque, engaje e torne-se um embaixador especialista.',
    showroom: '',
    retain:
      'Parabéns por completar seu treinamento! Você agora desbloqueou seu recurso de referência para reter seu conhecimento especializado e habilitar seus esforços de vendas. Use esta área para responder expertamente uma pergunta sobre produto ou até mesmo como uma apresentação de vendas improvisada — a qualquer hora, em qualquer lugar e de qualquer dispositivo.',
    retainAmbassador:
      'Parabéns por completar seu treinamento! Você agora desbloqueou seu recurso de referência para reter seu conhecimento especializado e habilitar seus esforços de vendas. Use esta área para responder expertamente uma pergunta sobre produto ou até mesmo como uma apresentação de vendas improvisada — a qualquer hora, em qualquer lugar e de qualquer dispositivo.',
    promote: 'Compartilhe estes itens para despertar interesse e iniciar uma conversa com clientes e prospects.',
    promoteAmbassador:
      'Aqui você encontra recursos para se manter atualizado sobre o essencial do turismo, além de itens interessantes para compartilhar com visitantes e ajudá-los a vivenciar o melhor do destino.',
    sell: 'Responda perguntas de clientes e feche a venda como um profissional com recursos profundos e suporte de vendas direcionado.',
    favorites: 'Confira seu conteúdo pessoalmente favoritado',
    search: 'Procure por todo o conteúdo',
    subapps: 'Ganhe uma Insígnia de Especialista completando estes módulos de parceiros rápidos de capítulo único.',
    subAppsFull: 'Alcance status de especialista completo conhecendo nossos parceiros',
    maintrainings: 'Complete estes módulos essenciais para ganhar seu certificado.',
    subtrainings: 'Eleve seu jogo e ganhe uma insígnia para cada capítulo de especialização abaixo.',
    fastTrack: 'Você está atualmente no Fast Track. Conclua-o para obter sua nota!',
  },
  general: {
    chapter: 'Capítulo',
    next: 'Próximo',
    yes: 'Sim',
    no: 'Não',
    previous: 'Anterior',
    submit: 'Enviar',
    back: 'Voltar',
    close: 'Fechar',
    page: 'Página',
    search: 'Buscar',
    selectLanguage: 'Selecionar idioma',
    logIn: 'Entrar',
    logOut: 'Sair',
    viewItem: 'Ver {type}',
    imageNotFound: 'Imagem não encontrada',
    noResultsFor: 'Nenhum resultado foi encontrado para {query}',
    noFavorites: 'Você ainda não tem favoritos.',
    noMessages: 'Você ainda não recebeu mensagens!',
    resultsFor: 'Resultados para: {{query}}',
    showAll: 'Mostrar todos',
    connectionError: 'Erro de conexão',
    alreadyExists: 'Já existe',
    pageNotFound: '404 Página Não Encontrada!',
    oops: 'Ops...',
    overview: 'Retornar à visão geral',
    complete: 'Continuar',
    courseComplete: 'Capítulo Completo!',
    chapterComplete: 'Capítulo Concluído!',
    message: '{count} Mensagem',
    messagePlural: '{count} Mensagens',
    viewBadge: 'Ver',
    downloadBadge: 'Baixar Insígnia',
    viewBadge2: 'Insígnia',
  },
  itemTypes: {
    image: 'Imagem',
    brochure: 'Coleção',
    layout: 'Layout',
    web: 'Website',
    pdf: 'PDF',
    carousel: 'Coleção',
  },
  questions: {
    dials: 'Gire os mostradores para corresponder à resposta',
    fitb: 'Preencha o(s) espaço(s) em branco',
    flip: 'Mude o número para corresponder à resposta',
    multipleChoice: 'Escolha a(s) resposta(s) correta(s)',
    slider: 'Escolha a resposta correta usando o controle deslizante',
    map: 'Responda a pergunta tocando no local correto no mapa',
    dropdown: 'Escolha...',
    true: 'Verdadeiro',
    false: 'Falso',
    arrangeTheWords: 'Clique nas palavras na ordem correta para completar a frase e depois clique em Enviar:',
    matchTheSentence:
      'Clique em uma frase à esquerda e depois na correspondente à direita. Combine todos os pares para completar a pergunta.',
  },
  reportCard: {
    download: 'Baixar',
    email: 'E-mail',
    print: 'Imprimir',
  },
  cookies: {
    consent: 'ACEITAR',
    optout: 'Recusar',
    settings: 'Configurações de Privacidade',
    message:
      'Você não nos disse nada sobre suas preferências de privacidade de dados! Tudo bem, mas gostaríamos de oferecer a melhor experiência usando o Sales Companion.',
    disabled: 'Parece que você desabilitou o uso de cookies.',
    use: 'O {{appName}} requer o uso de cookies para oferecer a melhor experiência.',
    details: 'Para que os cookies são usados?',
    enable: 'Veja como habilitar seus cookies {{here}}.',
    here: 'aqui',
  },
  notLoggedIn: {
    super: 'Você não está logado',
    title: 'Você precisa estar logado para ver este conteúdo',
    guest: 'Convidado',
  },
  demo: {
    message:
      'Este website é uma demonstração do produto final. Está atualmente em desenvolvimento e não é um produto completo.',
    consent: 'Entendido!',
  },
  share: {
    header: 'Compartilhe este recurso em suas redes sociais favoritas!',
    download: 'Baixar',
    button: 'Compartilhar',
  },
  sharing: {
    copyURL: 'Copiar Link',
    copied: 'Copiado',
  },
  breadCrumbs: {
    page: 'Página',
  },
  onMobile: {
    header: 'Parece que você está tentando acessar o app {appName} de um dispositivo móvel',
    body: 'Para baixar este programa simplesmente visite sua loja de aplicativos e procure por {appName} ou clique em um dos botões abaixo',
    benefits: {
      header: 'Isso fornecerá a você:',
      1: 'Aprenda, Promova e Venda em Movimento',
      2: 'Treinamento Multimídia em Todos os Dispositivos',
      3: 'Certificado de Conclusão',
      4: 'Apresentações de Vendas Prontas',
      5: 'Materiais Promocionais de Alto Impacto',
      6: 'Diretório de Produtos em Tempo Real',
      7: 'Notícias e Atualizações Oportunas',
    },
  },
  directoryView: {
    search: 'Buscar...',
    amountOfResults: 'Quantidade de resultados: ',
    filter: 'Filtro',
    filters: 'Filtros:',
    subFilter: 'Subfiltro',
    category: 'Categoria',
    subcategory: 'Subcategoria',
    resetFilters: 'Redefinir Filtros',
    showResults: 'Mostrar Resultados',
    clear: 'Limpar',
    noResults: 'Nenhum resultado encontrado. Por favor tente com uma busca diferente.',
    resetMap: 'Redefinir Mapa para o Início >',
    viewNow: 'Ver Agora >',
    viewWebsite: 'Visitar website',
    viewOnMap: 'Ver no mapa',
    amenities: {
      gym: 'Academia/Centro de Fitness',
      spa: 'Spa',
      meeting_room: 'Salas de Reunião/Conferência',
      pools: 'Piscina',
      accessible_property: 'Quartos Acessíveis',
      bars: 'Bar/Lounge',
      golf: 'Golfe/Mini-Golfe',
      beachfront: 'Acesso Privado à Praia',
      restaurants: 'Restaurante',
      waterfront: 'Beira-Mar',
      villa_product: 'Villa',
      non_smoking_resort: 'Resort para Não Fumantes',
      four_star: '4 Estrelas',
      five_star: '5 Estrelas',
      four_star_diamond: '4 Estrelas Diamond',
      five_star_diamond: '5 Estrelas Diamond',
      kitchenette_extended_stay: 'Kitchenette/Estadia Prolongada',
      all_suite: 'Todo em Suítes',
      family_friendly: 'Ideal para Famílias',
      casino: 'Cassino',
      downtown: 'Centro da Cidade',
      on_strip: 'Na Strip',
      private_airstrip: 'Pista de Pouso Privada',
      fishing_lodge: 'Pousada de Pesca',
      dive_center: 'Centro de Mergulho',
      selfCatering: 'Com Cozinha Própria',
      marina: 'Marina',
    },
  },
  directoryProfileView: {
    website: 'Site:',
    phone: 'Telefone:',
    altPhone: 'Telefone alternativo:',
    tollFree: 'Número gratuito:',
    fax: 'Fax:',
    address: 'Endereço:',
    about: 'Sobre:',
    starRating: 'Classificação por estrelas:',
    cuisine: 'Cozinha:',
    email: 'E-mail:',
    contactPerson: 'Pessoa de Contato:',
    experiences: 'EXPERIÊNCIAS',
    accommodationType: 'Tipo de Acomodação:',
    amenitiesNumberOfRooms: 'Número de Quartos: ',
    amenitiesTitle: 'Comodidades:',
    socialsTitle: 'REDES SOCIAIS:',
    socialTripadvisor: 'TripAdvisor',
    socialYelp: 'Yelp',
    socialYoutube: 'YouTube',
    socialInstagram: 'Instagram',
    socialFacebook: 'Facebook',
    socialTwitter: 'X',
    socialPinterest: 'Pinterest',
    socialMedia: 'Redes sociais',
    numberOfRoomsTitle: 'Número de quartos:',
    roomsCount: 'Quartos: {count}',
    listingNotFound: 'Anúncio não encontrado',
  },
  directory: {
    artsentertainment: 'Arte e Entretenimento',
    conventionservices: 'Serviços de Convenção',
    divingsnorkeling: 'Mergulho e Snorkeling',
    film: 'Cinema',
    hotels: 'Hotéis',
    lgbtgymsandspas: 'LGBT+: Academias e Spas',
    lgbtshopping: 'LGBT+: Compras',
    lgbtwheretostay: 'LGBT+: Onde Ficar',
    multiculturaldining: 'Multicultural: Gastronomia',
    multiculturalnightlife: 'Multicultural: Vida Noturna',
    nightlife: 'Vida Noturna',
    petfriendly: 'Pet-Friendly',
    restaurants: 'Restaurantes',
    shopping: 'Compras',
    spas: 'Spas',
    sports: 'Esportes',
    transportation: 'Transporte',
    venues: 'Locais de Eventos',
    waterways: 'Vias Aquáticas',
    waystoplay: 'Formas de Se Divertir',
    weddinglocations: 'Locais para Casamento',
    weddingvendors: 'Fornecedores de Casamento',
    attraction: 'Atrações',
    cvb: 'Órgãos de Turismo',
    accommodation: 'Acomodações',
  },
  preregisterview: {},
  custom: {
    splitUsers: 'Eu Sou Um ...',
    brandAmbassador: 'Embaixador da Marca',
    travelPro: 'Profissional de Viagem',
  },
  rewards: {
    rewards: 'Recompensas',
    title: 'Bem-vindo ao Centro de Recompensas',
    subheader: 'Acompanhe e Compartilhe Submissões de Reserva e Recompensas',
    titleAmbassador: 'Bem-vindo ao Centro de Conquistas',
    subheaderAmbassador:
      'Acompanhe suas conquistas de treinamento, resgate suas recompensas e compartilhe suas certificações.',
    lockedPopupNotGraduated:
      'Acesse esses benefícios exclusivos para formandos concluindo o treinamento e obtendo seu certificado ',
    button: 'Enviar sua reserva',
    products: 'Marketplace',
    viewAllBookings: 'Reservas',
    viewLeaderboard: 'Ranking',
    viewDashboard: 'Painel de Pontos',
    viewRewards: 'Visão Geral',
    home: {
      entries: 'Entradas Atuais',
      trainingAchievements: 'CONQUISTAS DE TREINAMENTO',
      trainingAchievementsText:
        'Acompanhe seu progresso de treinamento, certificações e o status de suas recompensas metálicas nesta página. Você também poderá baixar e compartilhar seu diploma, bem como qualquer distintivo que tenha conquistado.',
      trainingAchievementsTextNoMetallic:
        'Acompanhe seu progresso de treinamento e o status de suas certificações nesta página. Você também poderá baixar e compartilhar seu diploma, bem como qualquer distintivo que tenha conquistado.',
      bookingContests: 'PAINEL DE RESERVAS',
      bookingContestsText: 'Acompanhe e gerencie facilmente as submissões de reservas atuais no Painel de Reservas.',
      submitBooking: 'ENVIAR RESERVAS',
      submitBookingText: 'É aqui que você enviará as reservas para inclusão em concursos de reservas.',
      currentContest: 'CONCURSO ATUAL',
      currentContests: 'CONCURSOS ATUAIS',
      contestEnterBookings: 'inserindo suas reservas',
      contestNow: ' agora!',
      contestSeeOther: 'Ver outros ',
      contestTerms: 'Termos e Condições',
      noContest: 'O concurso não está disponível atualmente.',
    },
    bookingRewardsView: {
      title: 'Marketplace',
    },
    bookingsView: {
      title: 'Reservas',
    },
    leaderboardScreen: {
      title: 'RANKING \n de Pontos',
      earnedpts: 'MEUS PONTOS GANHOS:',
      pointsWall: 'RASTREADOR TOP 5 DE PONTOS:',
      startEarning: 'Comece agora a ganhar XPs e junte-se ao ranking!',
      prizes: 'Prêmios',
      tAndC: 'Termos e Condições se aplicam*',
      pointsOverview: {
        title: 'Como ganhar pontos',
        booths: 'Visitar Vitrines de Expositores',
        breakoutSessions: 'Participar de Sessões Paralelas e Destaques de Destino',
        trainingSessions: 'Completar um Capítulo de Treinamento',
        adventureSpotlights: 'Dicas de Viagem em Família',
        share: 'Compartilhar Conteúdo',
        shareMax: '(até {maxSharePoints} pontos)',
        shareInfo:
          'O compartilhamento é contado compartilhando conteúdo de estande no X e Facebook ou compartilhando o estande inteiro com colegas ou clientes.',
        viewVideo: 'Ver Vídeo',
      },
    },
    dashboardView: {
      title: 'Painel de Reservas',
      subtitle: 'Acompanhe e Gerencie Suas Entradas de Reserva Aqui.',
      badge: 'Insígnias',
      activity: 'Painel de Reservas',
      manage: 'Gerenciar Reservas',
      manageSub:
        'Ordene usando os botões acima e clique em qualquer registro para gerenciar detalhes da submissão. Todas as entradas pendentes serão verificadas dentro de 72 horas. ',
      noBookings: 'Não há registros para exibir.',
      state: {
        approvedEntries: 'Entradas Aprovadas',
        pendingEntries: 'Entradas Pendentes',
        declinedEntries: 'Entradas Recusadas',
        viewAll: 'Ver Todas',
      },
      columns: {
        wholesaler: 'Atacadista',
        clientLastName: 'Sobrenome do Cliente',
        totalCostUsd: 'Custo Total USD',
        hotelName: 'Nome do Hotel',
        hotelConfirmNumber: 'Número de Confirmação do Hotel',
        flightNumber: 'Número do Voo',
        typeOfBooking: 'Tipo de Reserva',
        checkIn: 'Check-In',
        checkOut: 'Check-Out',
        status: 'Status',
      },
    },
    bookingForm: {
      title: 'Formulário de Submissão de Reserva',
      subTitle: 'Digite sua reserva:',
      required: '* Indica um campo obrigatório',
      email: 'E-mail do Agente',
      agentFirstName: 'Primeiro Nome do Agente',
      agentLastName: 'Sobrenome do Agente',
      company: 'Nome da empresa',
      iata: 'IATA/CLIA #',
      stateProvince: 'Estado/Província',
      postalCode: 'CEP *',
      country: 'País',
      bookingNumber: 'Número de Confirmação da Reserva',
      numberOfGuests: 'Número de Hóspedes Adultos',
      bookingDate: 'Data da Reserva',
      tourOperator: 'Operadora de Turismo / Método de Reserva',
      firstName: 'Primeiro Nome',
      lastName: 'Sobrenome do Hóspede',
      guestLastName: 'Sobrenome do Hóspede',
      clientLastName: 'Sobrenome do Cliente',
      confirmationNumber: 'Número de Confirmação do Hotel',
      flightNumber: 'Número do Voo',
      hotelName: 'Nome do Hotel',
      accommodation: 'Resort/Hotel/Acomodações reservadas',
      select: 'Selecione uma opção',
      wholesaler: 'Nome do Atacadista (se aplicável): se esta é uma reserva direta, digite NENHUM',
      arrivalDate: 'Data de Check-In',
      departureDate: 'Data de Check-Out',
      lengthOfStay: 'Duração da Estadia (em Noites)',
      totalNights: 'Total de Noites',
      reservationNumber: 'Número da Reserva',
      rooms: 'Número de Quartos',
      stay: 'Duração da Estadia (em Noites)',
      airline: 'Companhia Aérea / Transportadora (código de 2 dígitos)',
      originAirport: 'Aeroporto de Origem (código de aeroporto de 3 letras)',
      destination: 'Destino/ilha (código de aeroporto de 3 letras)',
      cost: 'Custo Total da Reserva (use apenas decimais)',
      totalCost: 'Custo Total',
      file: 'Upload de Comprovante RezSnap™',
      disclaimer: '* Campos obrigatórios',
      button: 'Enviar sua reserva',
      sub: 'Suas informações',
      sub2: 'Informações da reserva',
      guests: 'Número de Passageiros',
      numberOfPassengers: 'Número de Passageiros',
      accommodationBooked: 'Resort/Hotel/Acomodações reservadas',
      accommodationCharterCompany: 'Hotel, Villa, Empresa de aluguer de embarcações',
      propertyCharterCompany: 'Imobiliária / Empresa de aluguer de embarcações',
      dragAndDrop: 'Arraste e solte alguns arquivos aqui, ou clique para selecionar arquivos',
      acceptedFiles: 'Somente arquivos .jpeg, .png e .pdf serão aceitos. O tamanho máximo do arquivo é 100mb.',
      missingRequiredFields: 'Por favor preencha todos os campos obrigatórios',
      invalidNumber: 'Deve ser um número maior que 0.',
    },
    bookingFormCustom: {
      app1781: {
        fields: {
          previousVisits: 'Número de Visitas Anteriores ao Caribe Mexicano',
          ambassadorReferralHeader: 'Indicação de Embaixador',
          referralFirstName: 'Primeiro Nome',
          referralFirstNamePlaceholder: 'Primeiro Nome (opcional)',
          referralLastName: 'Sobrenome',
          referralLastNamePlaceholder: 'Sobrenome (opcional)',
          referralEmail: 'E-mail',
          referralEmailPlaceholder: 'E-mail (opcional)',
        },
      },
      app1439: {
        fields: {
          preOrPostCruise: 'Esta reserva é para uma estadia pré ou pós-cruzeiro?',
          tripPurpose: 'Propósito da Viagem',
          departureAirport: 'Aeroporto de partida (código de aeroporto de 3 letras)',
        },
      },
    },
    TermsAndConditions: {
      title: 'Termos e Condições',
      button: 'Voltar',
    },
    thankYouPage: {
      thanks: 'Obrigado',
      congrats: 'Parabéns, ',
      body: 'sua reserva foi recebida e enviada ao supervisor da campanha para verificação.',
    },
    menu: {
      home: 'Centro de\nRecompensas',
      homeAmbassador: 'Visão Geral',
      achievements: 'Conquistas de\nTreinamento',
      bookings: 'Painel de\nReservas',
      form: 'Enviar\nReservas',
    },
  },
  badgeView: {
    title: 'Realizações de treinamento',
    subtitle:
      'Acompanhe o progresso do seu treinamento, as certificações e o status das recompensas metálicas nesta página. Você também poderá fazer o download e compartilhar seu diploma {program_name_short}, bem como todos os distintivos que tiver conquistado.',
    subtitleNoMetallic:
      'Acompanhe o progresso do seu treinamento e o status das suas certificações nesta página. Você também poderá fazer o download e compartilhar seu diploma {program_name_short}, bem como todos os distintivos que tiver conquistado.',
    badgeDisplayTitle: 'Status de realização metálica',
    badgeAchievement:
      'Você alcançou o status {rank}! Clique no ícone à direita para visualizar e compartilhar seu status.',
    bronze: 'Bronze',
    silver: 'Prata',
    gold: 'Ouro',
    platinum: 'Platina',
    complete: 'COMPLETO',
    diploma: 'Diploma',
    chapterBadges: 'Emblemas de especialização',
    partnerBadges: 'Emblemas de parceiros',
    tierRewards: 'Recompensas de nível',
    click: 'Clique ',
    here: 'aqui',
    bronzeReward: ' para acessar sua recompensa exclusiva de BRONZE.',
    silverReward: ' para acessar sua recompensa exclusiva de PRATA.',
    goldReward: ' para acessar sua recompensa exclusiva de OURO.',
    bronzeRewardTitle: 'Recompensa de Status Bronze',
    silverRewardTitle: 'Recompensa de Status Prata',
    goldRewardTitle: 'Recompensa de Status Ouro',
  },
  badgeDisplay: {
    status: 'Status de realização do treinamento',
  },
  tierCard: {
    achieved: 'Alcançado',
    modules: 'módulos',
    sales: 'Vendas',
    bookings: 'Reservas',
    or: 'ou',
    workingToward: 'Trabalhando para',
    currentTier: 'Nível Atual',
    workingTowardBronze: 'Complete a certificação para alcançar o status Bronze!',
    expiresIn: 'Expira em',
    days: 'dias',
    expiringToday: 'Expira hoje!',
    expiryDate: 'Data de Expiração',
    nextTier: 'Próximo Nível',
    nextGoal: 'Próxima Meta',
    allTiers: 'Todos os Níveis',
    bronzeDescription: 'Recompensa consultores que completam o básico e mostram compromisso inicial.',
    silverDescription: 'Reconhece consultores que vendem consistentemente e permanecem engajados.',
    goldDescription: 'Recompensa os melhores performers profundamente investidos em vendas.',
    title: {
      bronze: 'Bronze',
      silver: 'Prata',
      gold: 'Ouro',
    },
    requirement: {
      bronze: 'Complete a Certificação de Especialista em Bahamas',
      silver: 'Ganhe $5.000+ em vendas de viagens para Bahamas ou 5+ reservas',
      gold: 'Ganhe $15.000+ em vendas de viagens para Bahamas ou 15+ reservas',
    },
    tierCopy: 'Parabéns! Você alcançou o status {tier}!',
  },
  search: {
    pages: 'Páginas',
    resources: 'Recursos',
  },
  categories: {
    all: 'Todos',
    accommodations: {
      accommodations: 'Acomodações',
      bedbreakfast: 'Pousada',
      campgroundsrvparks: 'Campings e Parques para Trailers',
      condo: 'Condomínio',
      hotel: 'Hotel',
      vacationrentals: 'Aluguéis de Temporada',
    },
    attractions: 'Atrações',
    dining: 'Gastronomia',
  },
  preregisterView: {
    comingSoon: 'Em breve:',
    title: 'O novo {appName}',
    success:
      'O seu pré-registo no programa foi concluído com sucesso. Receberá um e-mail quando o programa for lançado.',
    fillRequired: 'Por favor, preencha todos os campos obrigatórios: {fields}',
    email: 'E-mail',
    firstName: 'Nome próprio',
    lastName: 'Apelido',
    agencyName: 'Nome da agência',
    country: 'País',
    selectDefault: 'Por favor, selecione uma opção abaixo',
    requiredFields: '* Campos obrigatórios',
    submit: 'Submeter',
    isRegistered:
      'O seu pré-registo no programa foi concluído com sucesso. Receberá um e-mail quando o programa for lançado.',
    somethingWentWrong: 'Algo correu mal. Por favor, tente novamente.',
  },
  profileImageView: {
    currentImage: 'A sua imagem de perfil atual:',
    uploadImage: 'Carregar a sua imagem de perfil:',
    chooseAFile: 'Escolha um ficheiro…',
    cancel: 'Cancelar',
    backButton: 'Voltar',
    uploadButton: 'Carregar imagem de perfil',
    saveButton: 'Guardar esta imagem de perfil',
    fileTooLargeTitle: 'O tamanho do ficheiro a carregar excedeu o limite',
    fileTooLargeText: 'O tamanho máximo para o carregamento de imagens é de 10 MB',
  },
  FastTrackView: {
    incorrectAnswer: 'Isso não está correto.',
    question: 'Q{current}/{total}',
    questionCounter: '{current} de {total} perguntas',
    score: 'Pontuação: {correct}/{total}',
    nextIn: 'Próxima em {count}s',
    goToNextQuestion: 'Ir para a próxima pergunta',
    gradeEarned: 'Nota obtida',
    correct: 'Correto',
    completeFastTrack: 'Concluir Fast Track',
    beginFullTraining: 'Iniciar treinamento completo',
    fastTrackComplete: 'Fast Track concluído!',
    fastTrackNotPassed: 'Fast Track não aprovado',
    downloadDiploma: 'Baixar diploma',
    resultSuccessMessage: 'Parabéns — você passou no Fast Track e ganhou seu diploma!',
    resultAchievementsPrefix: ' Você pode acessar seu diploma na área de ',
    resultAchievementsLinkText: 'Conquistas de Treinamento',
    resultAchievementsSuffix: '.',
    resultFailureMessage:
      'Infelizmente, você não passou no Fast Track. Ele é limitado a uma tentativa por usuário — mas você ainda pode ganhar seu diploma! Trabalhe no treinamento completo para ampliar seu conhecimento e conclua no seu próprio ritmo.',
  },
  smartAssist: {
    title: 'TA SmartAssist',
    pastConversations: 'Conversas anteriores',
    showNextSuggestionsAria: 'Mostrar próximas sugestões',
    headingAria: 'Abrir TA SmartAssist',
    headingResumeAria: 'Retomar conversa',
    homePlaceholder: 'Ask anything about travel in {destinationLabel}…',
    recentConversations: 'Conversas recentes',
    previousConversations: 'Conversas anteriores',
    noRecentConversations: 'Nenhuma conversa recente',
    deleteConversationAria: 'Excluir conversa',
    chatSubtitle: 'Ask TA Smart Assist Anything About Travel in {destinationLabel}',
    startNewConversationAria: 'Nova conversa',
    sourcesFromApp: 'Fontes',
    loadingConversation: 'Carregando conversa…',
    welcomePrompt: 'Ask any travel related questions about {destinationLabel}',
    loadingResponse: 'A processar…',
    messageLimitReached: 'Limite de mensagens atingido',
    messageRemaining: '{remaining} mensagem restante',
    messagesRemaining: '{remaining} mensagens restantes',
    quotaBarAria: '{remaining} de {total} mensagens restantes',
    resetsAt: 'Reinicia em {resetLabel}',
    quotaChaptersPrompt: 'Earn certification for unlimited usage.',
    chatPlaceholder: 'Ask any travel related questions…',
    greetingFallback: 'Hi there',
    greetingName: 'Hi {firstName}',
    defaultDestination: 'este destino',
    appNotReady: 'App ainda não configurada.',
    signInRequired: 'Inicie sessão para continuar.',
    genericError: 'Ocorreu um erro. Tente novamente.',
    requestFailed: 'Pedido falhado. Tente novamente.',
    sourceFallback: 'Fonte',
    fallbackSuggestions: {
      bestBeaches: 'Melhores praias',
      familyActivities: 'Atividades em família',
      hiddenGems: 'Tesouros escondidos',
      roadTrips: 'Viagens de carro',
      dining: 'Melhores restaurantes',
      events: 'Próximos eventos',
    },
    structured: {
      confidenceThreshold: 'Confiança',
      confidenceThresholdPercentAria: 'Confiança: {percent}%',
      recommendation: 'Recomendação',
      alignment: 'Verificação de alinhamento',
      tailor: 'Para personalizar',
      tips: 'Dicas de eficiência',
    },
  },
  imageGallery: {
    noticeTitle: 'Aviso de uso de imagens',
    noticeText:
      'Todas as imagens estão licenciadas exclusivamente para {clientName} e não podem ser usadas sem permissão',
  },
  toolbox: {
    completion: 'Complete A Base para desbloquear este item',
  },
};
